export const css = {
  border: 'border border-gray-200',
  h50: 'h-[50px]',
  rounded: 'rounded-full'
}
